export default {
  unavailableForPaymentProvider: {
    id: 'discount_unavailable_for_payment_provider',
    defaultMessage: "Ack! Promo codes don't work with {paymentProvider} (yet).",
  },
}
